var _rect, _rect2, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSleepIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.3335,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#96CEFD"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4.3335,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#B5DEFF",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.8335 29C35.4103 29 37.5732 27.228 38.1701 24.836C37.7422 24.9429 37.2945 24.9996 36.8335 24.9996C33.7959 24.9996 31.3335 22.5371 31.3335 19.4996C31.3335 19.0388 31.3902 18.5913 31.4969 18.1636C29.1052 18.7607 27.3335 20.9234 27.3335 23.5C27.3335 24.4128 27.5558 25.2735 27.9493 26.0312M21.3335 23V19M19.3335 21H23.3335M22.3335 38C20.1244 38 18.3335 36.2091 18.3335 34C18.3335 32.0221 19.769 30.3796 21.655 30.0573C22.4623 27.697 24.6997 26 27.3335 26C29.6217 26 31.6107 27.2809 32.6227 29.1648C33.0079 29.0574 33.414 29 33.8335 29C36.3188 29 38.3335 31.0147 38.3335 33.5C38.3335 35.9853 36.3188 38 33.8335 38C30.0002 38 26.1668 38 22.3335 38Z",
    stroke: "#0265DC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepIcon);
export default __webpack_public_path__ + "static/media/SleepIcon.926e2eae55cd2452ccac647754155474.svg";
export { ForwardRef as ReactComponent };